import { useIsMobile } from '@/hooks/use-is-mobile';
import { useTracking } from '@/libs/analytics';
import { CH_CDN_URL } from '@/utils/constants';
import { EnumButtonName } from '@calm/evexia-analytics';
import { DS_HEIGHT, DS_WIDTH } from '@calm/evexia-design-tokens';
import { RewardPartnerRewardDetail } from '@calm/evexia-web-sdk';
import { Box, Button, Grid, Theme, Typography } from '@rhg/libs/material';
import Image from '@rhg/libs/next/image';
import { JoinDialogTrackProps } from '..';

const styleRewardName = {
    textDecoration: (theme: Theme) =>
        `${theme.palette.mode === 'light' ? 'initial' : 'underline'}`,
};
const styleAffiliateButton = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
};
const styleGridItem = {
    height: 'max-content',
};

interface RewardItemProps {
    reward: RewardPartnerRewardDetail;
    handleRewardClick: (reward: RewardPartnerRewardDetail) => void;
    trackProps?: JoinDialogTrackProps;
}

const RewardItem = ({
    reward,
    handleRewardClick,
    trackProps,
}: RewardItemProps) => {
    const isMobile = useIsMobile();
    const {
        state: { currentScreenName },
    } = useTracking();

    return (
        <Grid item sx={styleGridItem}>
            <Button
                trackButton={EnumButtonName.ProgramJoinedRewardDetails}
                trackProps={{
                    RewardName: reward.affiliatePartner,
                    SourceScreenName: currentScreenName,
                    ...trackProps,
                }}
                sx={styleGridItem}
                onClick={() => handleRewardClick(reward)}
            >
                <Box sx={styleAffiliateButton}>
                    <Image
                        src={`${CH_CDN_URL}${reward.logo.url}`}
                        alt={reward.logo.altText}
                        width={
                            isMobile
                                ? DS_WIDTH.LOGO_SMALL
                                : DS_WIDTH.LOGO_MEDIUM
                        }
                        height={
                            isMobile
                                ? DS_HEIGHT.LOGO_SMALL
                                : DS_HEIGHT.LOGO_MEDIUM
                        }
                    />
                    <Typography
                        variant="body1Demi"
                        color="primary.main"
                        textAlign="center"
                        sx={styleRewardName}
                    >
                        {reward.name}
                    </Typography>
                </Box>
            </Button>
        </Grid>
    );
};

export default RewardItem;
